__turbopack_context__.v({
  "divider": "HistoryViewFrames-module-scss-module__sPRRvq__divider",
  "dividerWrapper": "HistoryViewFrames-module-scss-module__sPRRvq__dividerWrapper",
});
